import { useEffect } from 'react'
import ReactGA from 'react-ga'
import { useLocation } from 'react-router-dom'

/**
 * Adapted from react routers usePageView demo:
 * https://reacttraining.com/react-router/web/api/Hooks/uselocation
 */
export function usePageViews() {
  const location = useLocation()
  useEffect(() => {
    ReactGA.ga('send', 'pageview', location.pathname)
  }, [location])
}
